// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Login Container */
.admin-login-container {
  max-width: 450px;
  margin: 0 auto;
  padding: 0 20px;
}

.login-card {
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.login-card h2 {
  color: #2d3748;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
  text-align: center;
  font-weight: 600;
}

.login-description {
  color: #718096;
  margin-bottom: 2rem;
  text-align: center;
  font-size: 0.95rem;
}

/* Error Message */
.error-message {
  background-color: #fed7d7;
  color: #c53030;
  padding: 0.875rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid #c53030;
  font-size: 0.9rem;
}

/* Login Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.login-form .form-group {
  margin-bottom: 0;
}

.login-form label {
  display: block;
  margin-bottom: 0.5rem;
  color: #2d3748;
  font-weight: 500;
  font-size: 0.95rem;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.login-form input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 0.875rem;
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  margin-top: 0.5rem;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.login-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Login Info */
.login-info {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
  text-align: center;
}

.login-info p {
  color: #718096;
  font-size: 0.85rem;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 480px) {
  .admin-login-container {
    padding: 0 15px;
  }

  .login-card {
    padding: 1.5rem;
  }

  .login-card h2 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminLogin.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Admin Login Container */\n.admin-login-container {\n  max-width: 450px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.login-card {\n  background: white;\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.login-card h2 {\n  color: #2d3748;\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.login-description {\n  color: #718096;\n  margin-bottom: 2rem;\n  text-align: center;\n  font-size: 0.95rem;\n}\n\n/* Error Message */\n.error-message {\n  background-color: #fed7d7;\n  color: #c53030;\n  padding: 0.875rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid #c53030;\n  font-size: 0.9rem;\n}\n\n/* Login Form */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.login-form .form-group {\n  margin-bottom: 0;\n}\n\n.login-form label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2d3748;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.login-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem;\n  font-size: 1.05rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  margin-top: 0.5rem;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.login-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Login Info */\n.login-info {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  text-align: center;\n}\n\n.login-info p {\n  color: #718096;\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .admin-login-container {\n    padding: 0 15px;\n  }\n\n  .login-card {\n    padding: 1.5rem;\n  }\n\n  .login-card h2 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
